import type { FC } from "react";
import { useOnce } from "@huub-web/ui";

import { useAuth } from "../../hooks/useAuth";

type AuthMiddlewareProps = Record<string, never>;

export const AuthMiddleware: FC<AuthMiddlewareProps> = () => {
  const { initializeMiddleware } = useAuth();

  useOnce(() => {
    initializeMiddleware();
  });

  return null;
};
